import _ from 'lodash';
import environment from '../../environment';
// import 'mapbox.js';

const worldMap = () => require('./index').default;

const halo = (() => {
    const layerView = new Map();
    const bubbleLayer = (currentMap = worldMap().getCurrent()) => {
        if (!layerView.has(currentMap._id)) {
            const layer = L.featureGroup();
            layer.addTo(currentMap);
            layerView.set(currentMap._id, layer);
        }
        return layerView.get(currentMap._id);
    };

    let _lastStoreSelected = 0;
    let _defaultPosition = null;

    L.Marker.prototype.bubbleAnimation = function (duration = 300, delay = 0) {
        return this.on('add', function () {
            _defaultPosition = {
                left: parseInt(L.DomUtil.getStyle(this._icon, 'marginLeft')),
                top: parseInt(L.DomUtil.getStyle(this._icon, 'marginTop')),
                zIndex: parseInt(L.DomUtil.getStyle(this._icon, 'zIndex')),
                width: parseInt(L.DomUtil.getStyle(this._icon, 'width')),
                height: parseInt(L.DomUtil.getStyle(this._icon, 'height')),
                start: parseInt(L.DomUtil.getStyle(this._icon, 'height')) / 2
            };

            $(this._icon).hide();
            $(this._icon).velocity('fadeIn', {
                duration,
                delay,
                complete: () => {
                    try {
                        if (this._icon) {
                            this._icon.style.zIndex = _defaultPosition.zIndex;
                        }
                    } catch (err) {
                        console.log(err);
                    }
                }
            });
        });
    };

    const _calculatePosition = (t, r, d) => {
        const angleSlice = Math.asin(d / r);
        const angleTotal = angleSlice * (t - 1);
        const rotation = (angleTotal - Math.PI) / 2;

        return n => [
            Math.cos((angleSlice * n) - rotation) * r,
            Math.sin((angleSlice * n) - rotation) * r
        ];
    };

    const _bubbleProjection = (position, size, offset = [0, 0]) => [
        position[0] + offset[0] + (size[0] / 2),
        position[1] + offset[1] + (size[1] / 2)
    ];

    const _getIcon = options => ({
        isHighlighted: (() => {
            if (options.check) { return options.check(); }

            return false;
        })(),
        highlight: L.icon({
            iconSize: [28, 28],
            iconAnchor: options.position,
            iconUrl: `${environment.get('IMAGES_HOST')}/${options.icon}.png`
        }),
        unhighlight: L.icon({
            iconSize: [28, 28],
            iconAnchor: options.position,
            iconUrl: options.iconOff
                ? `${environment.get('IMAGES_HOST')}/${options.iconOff}.png`
                : `${environment.get('IMAGES_HOST')}/${options.icon}.png`
        })
    });

    const hasBubbles = (id, currentMap = worldMap().getCurrent()) => {
        if (_lastStoreSelected === id && bubbleLayer(currentMap).getLayers().length > 0) {
            return true;
        } else {
            _lastStoreSelected = id;
            remove(300, currentMap);
            return false;
        }
    };

    const remove = (duration, currentMap = worldMap().getCurrent()) => {
        const layer = bubbleLayer(currentMap).getLayers();

        if (!_.size(layer)) {
            return;
        }

        if (duration) {
            layer.forEach((bubble, index) => {
                bubble._icon.style.zIndex = 0;
                $(bubble._icon).velocity('fadeOut', {
                    duration,
                    delay: duration > 0 ? (index) * 100 : 0,
                    complete() {
                        bubbleLayer(currentMap).removeLayer(bubble);
                    }
                });
            });
        } else {
            bubbleLayer(currentMap).clearLayers();
        }
    };

    const add = (options, duration, delay) => {
        const icon = _getIcon(options);

        const latLng = options.layer.getLatLng
            ? options.layer.getLatLng()
            : options.feature.geometry.coordinates;

        const bubble = L.marker(latLng, {
            icon: icon.isHighlighted ? icon.unhighlight : icon.highlight,
            zIndexOffset: 1000,
            title: options.title
        }).bubbleAnimation(duration, delay);
        bubbleLayer(options.map).addLayer(bubble);

        options.layer.on('remove', () => remove(0, options.map));

        worldMap().once('click contextmenu', () => remove(300, options.map));

        bubble.on('click', () => {
            if (options.click) {
                bubble.setIcon(icon.highlight);
                options.click();
            } else if (icon.isHighlighted) {
                icon.isHighlighted = false;
                if (_.isFunction(options.off)) { options.off(); }

                bubble.setIcon(icon.highlight);
            } else {
                icon.isHighlighted = true;
                if (_.isFunction(options.on)) { options.on(); }

                bubble.setIcon(icon.unhighlight);
            }
        });
    };

    const create = (bubbles, options) => {
        const _setPosition = _calculatePosition(bubbles.length, options.radius, 30);
        bubbles.forEach((layer, index) => {
            layer.position = _bubbleProjection(_setPosition(index), [28, 28], options.offset);
            add(layer, 300, (index) * 100);
        });
    };

    return {
        create,
        add,
        remove,
        hasBubbles
    };
})();

export default halo;



// WEBPACK FOOTER //
// ./src/scripts/core/map/halo.js